import React, { forwardRef, useState } from "react";
import SnTab from "@shared/components/SnTab";
import SnButton from "@shared/components/SnButton";
import { StyleSettings } from "../../../../../styles/StyleSettings";
import { Fade } from "@mui/material";
import MuiAlert from "@mui/material/Alert";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
  txt_script: string;
}

/**
 * 배포 스크립트 추출 도움창(Script 추출 도움창)
 */
const SN_SFA_ISSUE_REG_004_POP_001 = forwardRef(
  ({ selectedData, modalRef, txt_script }: popupProps, ref: React.Ref<any>) => {
    const [showToast, setShowToast] = useState(false);

    const copyAll = () => {
      navigator.clipboard.writeText(txt_script).then(() => {
        setShowToast(true);
        setTimeout(() => setShowToast(false), 1000);
      });
    };

    return (
      <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <div
          style={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <SnTab
            titles={["Script"]}
            width={"100%"}
            header={[<SnButton text={"전체복사"} onClick={() => copyAll()} />]}
            body={[
              <div
                style={{
                  height: "100%",
                  border: "1px solid rgb(186,191,199)",
                  overflow: "auto",
                  fontSize: StyleSettings.font,
                  borderRadius: "4px",
                  padding: "8px",
                  whiteSpace: "pre-wrap",
                }}
              >
                {txt_script}
              </div>,
            ]}
          />
          <Fade in={showToast} timeout={{ enter: 200, exit: 300 }}>
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1300,
              }}
            >
              <MuiAlert
                severity="success"
                variant="outlined"
                sx={{
                  backgroundColor: "#f5f5f5",
                  color: "black",
                  borderColor: "#ccc",
                  fontWeight: 500,
                  padding: "0px 10px",
                  "& .MuiAlert-icon": {
                    marginRight: "5px",
                  },
                }}
              >
                복사되었습니다.
              </MuiAlert>
            </div>
          </Fade>
        </div>
      </div>
    );
  }
);

export default SN_SFA_ISSUE_REG_004_POP_001;
